import { render, staticRenderFns } from "./FPotensiDeskripsi.vue?vue&type=template&id=4ce09e34&scoped=true"
import script from "./FPotensiDeskripsi.vue?vue&type=script&lang=js"
export * from "./FPotensiDeskripsi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce09e34",
  null
  
)

export default component.exports